import { Button, ButtonGroup, Grid } from "@mui/material";
import Templete from "../../template/Template";
import { useState } from "react";
import Apagar from "./Tabs/Apagar";

export default function Financeiro() {
    const [menuActive, setMenuActive] = useState("0");
    const [rows, setRows] = useState([]);

    return (
        <Templete menuActive="contas_pagar">
            <Grid container spacing={1}>
                <Grid item xs={false} sm={3}></Grid>
                <Grid item xs={12} sm={6}>
                    <ButtonGroup variant="outlined" fullWidth>
                        <Button
                            variant={menuActive === "1" ? "contained" : "outlined"}
                            onClick={() => setMenuActive("1")}
                            color="success"
                        >
                            A RECEBER
                        </Button>
                        <Button
                            variant={menuActive === "2" ? "contained" : "outlined"}
                            onClick={() => setMenuActive("2")}
                            color="error"
                        >
                            A PAGAR
                        </Button>
                        <Button
                            variant={menuActive === "3" ? "contained" : "outlined"}
                            onClick={() => setMenuActive("3")}
                        >
                            FLUXO DE CAIXA
                        </Button>
                    </ButtonGroup>
                </Grid>
                <Grid item xs={false} sm={3}></Grid>

                {menuActive === "2" && (
                    <Apagar />
                )}

            </Grid>
        </Templete>
    );
}